/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    name: "birthCertificateTitle",
    label: "Australian birth certificate"
  },
  {
    fieldType: FIELD.TEXT.PARAGRAPH,
    name: "birthCertificateIntroduction",
    description: [
      "Enter all fields as printed on your birth certificate."
    ]
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_birthcertificatedvs_givenname",
    label: "First name",
    validation: { max: 60 }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_birthcertificatedvs_middlename",
    label: "Middle name",
    validation: { max: 60 }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_birthcertificatedvs_surname",
    label: "Last name",
    fieldRequired: true,
    validation: { required: true, max: 50, regex: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/ }
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_birthcertificatedvs_dob",
    label: "Date of birth",
    disabled: true,
    hint: "For example, 31 3 2015",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2024
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.DROPDOWN,
    name: "greenid_birthcertificatedvs_registration_state",
    label: "State of issue",
    fieldRequired: true,
    options: [
      { text: "ACT", value: "ACT" },
      { text: "NSW", value: "NSW" },
      { text: "NT", value: "NT" },
      { text: "SA", value: "SA" },
      { text: "QLD", value: "QLD" },
      { text: "TAS", value: "TAS" },
      { text: "VIC", value: "VIC" },
      { text: "WA", value: "WA" }
    ]
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_birthcertificatedvs_registration_number",
    label: "Registration number",
    fieldRequired: true,
    validation: { required: true, max: 10 },
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Registration date",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_birthcertificatedvs_registration_date",
    label: "Registration date",
    hint: "For example, 31 3 1980",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2024
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_birthcertificatedvs_registration_year",
    label: "Registration year",
    fieldRequired: true,
    validation: { required: true, digits: 4 },
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_birthcertificatedvs_certificate_number",
    label: "Certificate number",
    validation: { max: 11 },
    //REQUIRED IF ACT OR NT
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Certificate date",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_birthcertificatedvs_certificate_printed_date",
    label: "Certificate date",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2024
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "greenid_birthcertificatedvs_tandc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: "on",
        text: "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity."
      }
    ]
  }
];